import axios from 'axios';
import { useEffect, useState } from 'react';
import { baseUrl, getCurrentUser } from '../../../util/host';

export const getFilterApiBase = () => baseUrl('REACT_APP_PRODUCT_FILTER_API_URL');

export const PRODUCT_FILTER_OPTIONS_PATH = '/v1/products/filter-options';

const filterHeaders = () => {
  const token = getCurrentUser()?.token || '';
  return {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    x_styliplm_internal_header: 'keystylirsf87hgdg57bh6dc65ch',
    token: `Bearer ${token}`,
  };
};

/**
 * Maps { id, name_en } array to the internal { id, label } option list shape,
 * sorted alphabetically by label.
 */
const toOptionList = (rows) =>
  (Array.isArray(rows) ? rows : [])
    .map((row) => ({
      id: row?.id,
      label: (row?.name_en ?? '').toString().trim(),
    }))
    .filter((r) => r.id != null && r.label)
    .sort((a, b) => a.label.localeCompare(b.label));

const EMPTY_MASTER = { soldBy: [], brandName: [], category: [] };

const fetchFilterMaster = async () => {
  const base = getFilterApiBase();
  if (!base) {
    console.warn(
      '[productFilterApiHelpers] REACT_APP_PRODUCT_FILTER_API_URL is not configured; '
      + 'skipping product filter options fetch. Restart the dev server after updating the env file.'
    );
    return EMPTY_MASTER;
  }
  const url = `${base}${PRODUCT_FILTER_OPTIONS_PATH}`;
  console.info('[productFilterApiHelpers] fetching product filter options', url);
  const res = await axios.get(url, { headers: filterHeaders() });
  const body = res?.data || {};
  const result = {
    soldBy: toOptionList(body.sold_by),
    brandName: toOptionList(body.brands),
    category: Array.isArray(body.categories) ? body.categories : [],
  };
  console.info(
    `[productFilterApiHelpers] loaded soldBy=${result.soldBy.length}, `
    + `brandName=${result.brandName.length}, categoryRoots=${result.category.length}`
  );
  return result;
};

let masterCache = null;
let masterPromise = null;

export const getProductFilterMaster = () => {
  if (masterCache) return Promise.resolve(masterCache);
  if (!masterPromise) {
    masterPromise = fetchFilterMaster()
      .then((data) => {
        masterCache = data;
        return data;
      })
      .catch((err) => {
        // Reset so subsequent mounts can retry cleanly.
        masterPromise = null;
        throw err;
      });
  }
  return masterPromise;
};

/** Hook that loads the shared product filter options once per app session. */
export const useProductFilterMaster = () => {
  const [data, setData] = useState(() => masterCache || EMPTY_MASTER);
  const [loading, setLoading] = useState(() => !masterCache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (masterCache) return undefined;
    let alive = true;
    setLoading(true);
    getProductFilterMaster()
      .then((d) => {
        if (!alive) return;
        setData(d);
        setLoading(false);
      })
      .catch((err) => {
        if (!alive) return;
        console.error('Failed to load product filter options', err);
        setError(err);
        setLoading(false);
      });
    return () => { alive = false; };
  }, []);

  return { ...data, loading, error };
};
